import { render, staticRenderFns } from "./HomeIdeasPlaceStart.vue?vue&type=template&id=8495dce0&scoped=true"
import script from "./HomeIdeasPlaceStart.vue?vue&type=script&lang=ts"
export * from "./HomeIdeasPlaceStart.vue?vue&type=script&lang=ts"
import style0 from "./HomeIdeasPlaceStart.vue?vue&type=style&index=0&id=8495dce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8495dce0",
  null
  
)

export default component.exports